import{useCoreContext as o}from"./CoreProvider.js";import{useCallback as r}from"../../external/preact/hooks/dist/hooks.js";function e(){const{resources:e}=o();return r(o=>e?.getImage(o),[])}export{e as default};
//# sourceMappingURL=useImage.js.map
